/**
 * The view for PAL-backed (streamline, guesty, RU etc) reservations.
 * We made a whole different view because many components differ from the original Reservation view.
 */

import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Banner, Loading, StayPanel, UnitPanel } from '../../../components';
import { QuestionPanel, TripInfo } from './components';
import _ from 'lodash';
import { StoreState } from '../../../types/store.type';
import { Splits } from '../../../types/split.type';
import { TranslationUtils } from '../../../utils';
import { StarRatingModal } from '../../../components/StarRatingModal/StarRatingModal';
import { useFeatureConfig } from '../../../services/optimizely/optimizelyHelper';

export const PalReservation: React.FC = () => {
    const trip = useSelector((store: StoreState) => store.trip);

    const [isShowingAppBanner, setIsShowingAppBanner] = useState(true);
    const [isStarRatingModalShow, setIsStarRatingModalShow] = useState(false);

    // Feature Flag
    const { isEnabled: isAppBannerEnable } = useFeatureConfig(Splits.GUESTS_PORTAL_MOBILE_APP, false);

    const { reservation, stay, unit, review } = trip;

    useEffect(() => {
        if (review && review.is_eligible && review.rating === null) {
            setIsStarRatingModalShow(true);
        }
    }, [review]);

    if (trip.isLoading) {
        return <Loading />;
    }

    if (!reservation || !stay || !unit) {
        return null;
    }

    const pm = unit.pms_data?.property_management;

    const handleAppBannerDismiss = () => {
        setIsShowingAppBanner(false);
    };

    const handleStarRatingModalDismiss = () => {
        setIsStarRatingModalShow(false);
    };

    return (
        <React.Fragment>
            <div>
                <div className="pl-0">{isAppBannerEnable && <Banner show={isShowingAppBanner} handleClose={handleAppBannerDismiss} />}</div>
                <h1 tabIndex={0} className="heading-large page-title">
                    {TranslationUtils.get('trip_overview')}
                </h1>

                <UnitPanel />

                <StayPanel />

                <div>
                    <span tabIndex={0} className="heading-caps-small head-title my-3">
                        {TranslationUtils.get('trip_all_set')}
                    </span>
                    <TripInfo />
                </div>

                {pm?.name && (pm?.email || pm?.phone) && (
                    <QuestionPanel name={pm.name} email={pm.email ?? undefined} phoneNumber={pm.phone ?? undefined} />
                )}
            </div>

            {review && (
                <StarRatingModal
                    reservation={reservation}
                    unit={unit}
                    review={review}
                    show={isStarRatingModalShow}
                    handleClose={handleStarRatingModalDismiss}
                />
            )}
        </React.Fragment>
    );
};
